import React from "react";
import FieldLabel from "../../../components/label";
import ChipSelect from "../../../components/chipSelect";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import {
  Box,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";

function FinancialUnderwritingForm({
  classes: { containerButton, formGroup, gridLabel, gridChip },
  block,
  checkITRStatus,
  changeChipSelect,
  cibilErrorMessage,
  errorMessage,
  errors,
  form,
  handleChangeOption,
  isFormSubmitted,
  itr_filled,
  modal,
  options,
  orderDetails,
  resendLink,
  sendITRLink,
  itrNotFilledMessage,
  terminateClickHandler,
}) {
  return (
    <Box
      p={1}
      sx={{
        maxHeight: 520, // or any height you prefer
        overflowY: "auto",
      }}
    >
      <Box direction="column">
        {block?.options && (
          <>
            <Card
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 1,
                pt: 0,
                m: 0,
                pb: 0,
                boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                transition: "box-shadow .2s",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Box>
                  <Box className={formGroup} textAlign={"left"}>
                    <Typography color="error" variant="caption">
                      {cibilErrorMessage}
                    </Typography>
                  </Box>

                  <Box>
                    <Grid container spacing={1}>
                      <Grid item xs={3}></Grid>
                      <Grid item xs={3}>
                        <Typography variant="subtitle1">Limit</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="subtitle1">Actual</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="subtitle1">Declared</Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} mt={1}>
                      <Grid item xs={3}>
                        <Typography variant="subtitle1">Credit</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {orderDetails?.cibil_criteria_score}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {isNaN(+orderDetails?.cibil_score)
                            ? "NEW"
                            : +orderDetails?.cibil_score}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">-</Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} mt={1}>
                      <Grid item xs={3}>
                        <Typography variant="subtitle1">Income</Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {orderDetails?.cibil_criteria_income}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {isNaN(+orderDetails?.cibil_income)
                            ? "NEW"
                            : +orderDetails?.cibil_income}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="caption">
                          {orderDetails?.annualIncome}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </CardContent>
            </Card>

            <Card
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 1,
                pt: 0,
                mt: 1,
                pb: 0,
                boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
                transition: "box-shadow .2s",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Box mt={2} justifyContent={"flex-start"} display={"flex"}>
                  <Typography variant="caption" textAlign={"left"}>
                    In case if you want to proceed with OTC Journey, then select
                    one among the following option.
                  </Typography>
                </Box>

                <Box className={formGroup}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} className={gridLabel}>
                      <FieldLabel label={"Financial Underwriting Document"} />
                    </Grid>
                    <Grid item xs={12} className={gridChip}>
                      <FormControl variant="outlined" fullWidth>
                        <Box
                          justifyContent="flex-start"
                          display="flex"
                          textAlign="left"
                          fullWidth
                        >
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            value={"ITR"}
                            onChange={() => {}}
                            name="language"
                            fullWidth
                            sx={{
                              height: 48, // set height
                              "& .MuiSelect-select": {
                                paddingY: 1.2, // control padding inside
                              },
                            }}
                            disabled
                          >
                            {[{ title: "Income Tax Return", value: "ITR" }].map(
                              (option) => {
                                return (
                                  <MenuItem
                                    key={`education-${option.value}`}
                                    value={option.value}
                                  >
                                    <Typography variant="caption">
                                      {option.title}
                                    </Typography>
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </Box>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>

                <Box className={formGroup} mt={1} pt={0} pb={0}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} className={gridLabel}>
                      <FieldLabel label={"Has the customer filed their ITR?"} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={gridChip}
                      justifyContent={"flex-start"}
                    >
                      <ChipSelect
                        compact={false}
                        fontWeight={"regular"}
                        fieldname={"itr_filled"}
                        handleChange={changeChipSelect}
                        options={options.itr}
                        selectedItem={itr_filled}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {!errorMessage && itr_filled === "NO" && (
                  <Box className={formGroup} mt={1} pt={0} pb={0}>
                    <Typography variant="caption" textAlign={"left"}>
                      Click on "TERMINATE JOURNEY" button to end the process as
                      the customer is not eligible to proceed further without
                      filing ITR.
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </>
        )}

        {block?.itr_link && (
          <>
            {!errorMessage && (
              <>
                <Box className={formGroup} textAlign={"left"}>
                  <Typography variant="caption">
                    The ITR link has been shared{resendLink ? " again" : ""}{" "}
                    with the customer.
                  </Typography>
                </Box>
                <Box className={formGroup} textAlign={"left"}>
                  <Typography variant="caption">
                    Kindly ask the customer to complete the ITR details fetch
                    using the provided link.
                  </Typography>
                </Box>
                <Box className={formGroup} textAlign={"left"}>
                  <Typography variant="caption">
                    Once completed, please verify the details and proceed with
                    the case accordingly.
                  </Typography>
                </Box>
              </>
            )}

            {errorMessage && (
              <Box className={formGroup} textAlign={"left"}>
                <Typography variant="caption" color="red">
                  {errorMessage}
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>

      <ErrorMessage errors={errors} modal={modal} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        {block?.options && (
          <>
            {itr_filled === "YES" && (
              <CallToAction
                buttonType={"click"}
                errorMessage={errorMessage}
                form={form}
                isDisabled={false}
                isFormSubmitted={isFormSubmitted}
                text={"Send ITR Link"}
                handleClick={() => sendITRLink()}
              />
            )}

            {itr_filled === "NO" && (
              <CallToAction
                buttonType={"click"}
                errorMessage={errorMessage}
                form={form}
                isDisabled={false}
                isFormSubmitted={isFormSubmitted}
                text={"TERMINATE JOURNEY"}
                handleClick={() => terminateClickHandler(itrNotFilledMessage)}
                color={"secondary"}
              />
            )}
          </>
        )}

        {block?.itr_link && (
          <>
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={false}
              isFormSubmitted={isFormSubmitted}
              text={"Check ITR Status"}
              handleClick={checkITRStatus}
            />

            <Grid container spacing={1} mt={0}>
              <Grid item xs={6}>
                <CallToAction
                  buttonType={"click"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={false}
                  isFormSubmitted={isFormSubmitted}
                  text={"Change Option"}
                  handleClick={handleChangeOption}
                  // variant={"outlined"}
                  color={"secondary"}
                />
              </Grid>
              <Grid item xs={6}>
                <CallToAction
                  buttonType={"click"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={false}
                  isFormSubmitted={isFormSubmitted}
                  text={"Resend Link"}
                  handleClick={() => sendITRLink(true)}
                  // variant={"outlined"}
                  color={"secondary"}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  FinancialUnderwritingForm
);
